import React from 'react'
import AuditDataListfromApi from '../../components/AuditDataListfromApi'

export default function MPRDetails() {
  return (
          <AuditDataListfromApi
        endpoint="/mpr"
        headerText="Monthly Progressive Report"
      />
    
  )
}

 